import { configureStore } from "@reduxjs/toolkit";
import BalanceReducer from "./slices/BalanceSlice";
import HistoryReducer from "./slices/HistorySlice";
import LoginReducer from "./slices/LoginSlice";
import NavMenuReducer from "./slices/NavMenuSlice";
import PageReducer from "./slices/PageSlice";
import settingReducer from "./slices/settingSlice";
import StyleReducer from "./slices/StyleSlice";
import TransactionTypeReducer from "./slices/TransactionTypeSlice";
import MissingDataReducer from "./slices/MissingDataSlice";
import CardBalanceReducer from "./slices/CardBalanceSlice";
import CardStatementReducer from "./slices/CardStatementsSlice";
import IncentivePayoutReducer from "./slices/IncentivePayoutSlice";
import IncentiveNoticeBoardReducer from "./slices/IncentiveNoticeBoardSlice";

export default configureStore({
	reducer: {
		balance: BalanceReducer,
		cardBalance: CardBalanceReducer,
		CardStatement: CardStatementReducer,
		config: StyleReducer,
		Payout: IncentivePayoutReducer,
		History: HistoryReducer,
		Login: LoginReducer,
		MissingData: MissingDataReducer,
		Nav: NavMenuReducer,
		NoticeBoard: IncentiveNoticeBoardReducer,
		Page: PageReducer,
		setting: settingReducer,
		TransactionType: TransactionTypeReducer,
	},
});
